import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';

const baseApiUrl = 'api/v1/order-items';

export default class TotalItemsSoldService {
  public retrieve(startDate?: string, endDate?: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/total-sold?${this.buildSearchQueryOpts(startDate, endDate)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  private buildSearchQueryOpts(startDate: string, endDate: string): string {
    if (startDate && endDate) {
      return `search=createdDate>${startDate},createdDate<${endDate}`;
    } else {
      return '';
    }
  }
}
